import type {
  AccessToken,
  AccessTokenPayload,
  AuthenticatedCredentials,
  AuthModeEnum,
  RefreshToken,
  SelfSignUpConsent,
  SelfSignUpResult,
  Token,
} from "../domain";

export abstract class AuthenticatorProvider {
  abstract signInWithPassword(
    email: string,
    password: string
  ): Promise<AuthenticatedCredentials | { pendingToken: string }>;
  abstract signInPrecheck(email: string): Promise<{ authMode: AuthModeEnum }>;
  abstract signInWithMagicLink(email: string, code: string): Promise<AuthenticatedCredentials>;
  abstract signInWithValidationEmail(pendingToken: string, code: string): Promise<AuthenticatedCredentials>;
  abstract signInWithTotp(pendingToken: string, challenge: string, code: string): Promise<AuthenticatedCredentials>;
  abstract signInWithSso(code: string): Promise<AuthenticatedCredentials>;
  abstract completeSelfSignUp(
    token: string,
    code: string,
    name: string,
    consent: SelfSignUpConsent
  ): Promise<AuthenticatedCredentials & SelfSignUpResult>;
  abstract requestRefreshToken(accessToken: AccessToken, refreshToken: RefreshToken): Promise<AuthenticatedCredentials>;
  abstract signOut(accessToken: AccessToken, refreshToken: RefreshToken): Promise<{ success: boolean }>;
  abstract validateToken(token: Token): Promise<{ valid: boolean }>;
  abstract extractAccessToken(accessToken: AccessToken): AccessTokenPayload;
  abstract requestMagicLink(email: string): Promise<void>;
  abstract requestPasswordReset(email: string): Promise<void>;
  abstract requestSignInSsoUrl(email: string): Promise<{ ssoUrl: string }>;
  abstract resetPassword(pendingToken: string, password: string): Promise<void>;
}
